import { render, staticRenderFns } from "./GeneralStudy.vue?vue&type=template&id=292de6aa&scoped=true&lang=pug&"
import script from "./GeneralStudy.vue?vue&type=script&lang=ts&"
export * from "./GeneralStudy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292de6aa",
  null
  
)

export default component.exports